<template>
    <div class=embed-page>

        <RichTextPopup :isActive="introActive" :content="post.content.rendered" :blocks="contentBlocks" @close-popup="back" @button-click="activateEmbed" />

        <Embed v-if="embedActive" :src="post.acf.embed_link" :active="embedActive" />

    </div>
</template>
<script>

import RichTextPopup from '../components/RichTextPopup'
import Embed from '../components/Embed'

export default {
    name : 'EmbedPage',
    props : {
        post    : Object,
    },
    data() {
        return {
            embedActive   : false   ,
            introActive   : true    ,
            content       : ''      ,
            contentBlocks : null    ,
        }
    },
    methods : {
        back() {
            this.$router.push({ name : this.$route.meta.parent });
        },
        activateEmbed() {
            this.embedActive = true;
            this.introActive = false;
        }
    },
    components : {
        RichTextPopup   ,
        Embed           ,
    },
    created() {
        console.log(this.hash)
        this.contentBlocks = this.post.acf.content_blocks || [];

        if (!this.post.content.rendered && !this.contentBlocks.length) { // no content, just launch the embed
            this.activateEmbed()

        } else {
            this.contentBlocks.push({
                acf_fc_layout : 'buttonBlock' ,
                buttonText    : 'Launch'      ,
            });
        }
    }
}
</script>